import {getMessageByKey, getEntityMessages} from '../services/msgService';
import {cacheData} from '../services/cacheService';
import {getLocale} from '.';

export const texts = {};
export const moreInfo = {};
const serverInitialized = {};

export function extractSqlMsg(json) {
    if (
        json.General &&
        json.General[0] &&
        json.General[0].SqlMessage &&
        json.General[0].SqlMessage[0]
    ) {
        return json.General[0].SqlMessage[0].message;
    } else {
        return '';
    }
}

export function getServerTextByKey({entity, key}) {
    if (texts[entity] && texts[entity][key]) {
        return Promise.resolve(texts[entity][key]);
    } else {
        return getMessageByKey(entity, key)
            .then(res => {
                const msg = extractSqlMsg(res);
                texts[entity] = texts[entity] || {};
                texts[entity][key] = msg;
                return msg;
            })
            .catch(err => console.log(err));
    }
}

function extractMessages(json) {
    if (json.General && json.General[0] && json.General[0].ExtMessage) {
        return json.General[0].ExtMessage;
    } else {
        return [];
    }
}

export function getServerTexts(entity, mapping) {
    if (serverInitialized[entity]) {
        return Promise.resolve();
    } else {
        serverInitialized[entity] = true;
        return getEntityMessages(entity)
            .then(res => {
                if (!res.cached) cacheData(entity, res);
                const messages = extractMessages(res);
                const textsMap = {};
                const moreInfoMap = {};
                messages.forEach(({num, message, HyperLinkedText, moreInfoText}) => {
                    const linkText = JSON.stringify(HyperLinkedText) || '';

                    textsMap[mapping[num]] = message || linkText;
                    if (moreInfoText) {
                        moreInfoMap[mapping[num]] = moreInfoText;
                    }
                });
                texts[entity] = Object.assign(texts[entity], textsMap);
                moreInfo[entity] = moreInfoMap;
            })
            .catch(err => console.log(err));
    }
}

export function initTexts(entity, fallbacks) {
    texts[entity] = fallbacks[getLocale()] || fallbacks['en'];
}
